<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="姓名">
              <a-input
                placeholder="请输入姓名"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="是否离职">
              <a-select v-model="queryParam.isLeave">
                <a-select-option :value="0">否</a-select-option>
                <a-select-option :value="1">是</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!-- 高级查询区域 -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>
    <!-- 导入 -->

    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handlDelete(record.id)">删除</a>
      </span>
    </a-table>
    <bondPersonnelModel ref="modalForm" @ok="modalFormOk"></bondPersonnelModel>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import JDate from '@/components/jeecg/JDate';
import customRender from '@/utils/customRender.js';
import bondPersonnelModel from './bondPersonnelModel.vue';
import { filterObj } from '@/utils/util';
import { uploadAction, postAction, getAction, downFile } from '@/api/manage';
export default {
  name: 'ProductsQuotationList',
  components: {
    JDate,
    bondPersonnelModel
  },
  data() {
    return {
      description: '产品报价管理页面',
      fileList: [],
      showDialog: false,
      showLead: false,
      uploading: false,
      loading: false,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'createTime'
        // order: 'desc',
      },
      queryParam: {
        name: '',
        isLeave: ''
      },

      // 表头
      columns: [
        {
          title: '姓名',
          align: 'center',
          sorter: true,
          dataIndex: 'name'
        },
        {
          title: '岗位职责',
          align: 'center',
          dataIndex: 'responsibilityType',
          customRender: text => {
            if (text == 0) {
              return '投资交易相关人员';
            } else if (text == 1) {
              return '中后台核对专岗人员';
            }
          }
        },
        {
          title: '岗位分类',
          align: 'center',
          dataIndex: 'positionType'
        },
        {
          title: '所在部门',
          align: 'center',
          dataIndex: 'dept',
          customRender: customRender
        },
        {
          title: '办公电话',
          align: 'center',
          dataIndex: 'tel',
          customRender: customRender
        },
        {
          title: '是否离职',
          align: 'center',
          dataIndex: 'isLeave',
          customRender: text => {
            if (text == 0) {
              return '否';
            } else if (text == 1) {
              return '是';
            } else {
              return text;
            }
          }
        },
        {
          title: '离职日期',
          align: 'center',
          dataIndex: 'leaveDate',
          customRender: customRender
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/person/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/cont/person/del',
        deleteBatch: process.env.VUE_APP_CMS_CONTENT + '/cont/person/delBatch'
      }
    };
  },
  created() {
    this.getList();
  },

  methods: {
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      params.personType = 1;
      getAction(that.url.list, params)
        .then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource = res.result.records;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    //添加
    handleAdd: function(course) {
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }
      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    //获取表格中点中的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //编辑
    handleEdit(record) {
      console.log(record);
      // let responsibilityType =
      //   record.responsibilityType == 1
      //     ? '中后台核对专岗人员'
      //     : '投资交易相关人员';
      // record.responsibilityType = responsibilityType;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    //批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        let that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handlDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.getList();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
